// extracted by mini-css-extract-plugin
export default {"sidebar":"FilterSidebar_sidebar__2IzzU","active":"FilterSidebar_active__2J6et"};